import React from 'react';
const benefits = [{
  icon: '🔬',
  title: 'Criteri Biomeccanici',
  desc: 'Progettato secondo criteri biomeccanici e clinici rigorosi per la massima sicurezza.',
  color: 'from-primary/10 to-primary/5',
  borderColor: 'border-primary/20'
}, {
  icon: '📈',
  title: 'Tutti i Livelli',
  desc: 'Adatto per livelli Base, Intermedio e Avanzato. Progressioni logiche e fluide.',
  color: 'from-secondary/10 to-secondary/5',
  borderColor: 'border-secondary/20'
}, {
  icon: '💻',
  title: 'Multi-Dispositivo',
  desc: 'Compatibile con Tablet, Smartphone, PC e pronto per la stampa in alta qualità.',
  color: 'from-accent-sage/10 to-accent-sage/5',
  borderColor: 'border-accent-sage/20'
}];
export function BenefitsSection() {
  return <section className="w-full bg-bg-main py-20 px-4" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main text-center mb-16 tracking-tight" data-id="element-3">
          Standard Professionale Garantito
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-8" data-id="element-4">
          {benefits.map((benefit, i) => <div key={i} className="bg-white p-8 rounded-3xl border border-border-light shadow-[0_4px_20px_rgba(201,137,155,0.05)] flex flex-col gap-4 hover:-translate-y-1 transition-transform duration-300 relative overflow-hidden group" data-id="element-5">
              <div className={`absolute inset-0 bg-gradient-to-br ${benefit.color} opacity-0 group-hover:opacity-100 transition-opacity duration-500`} data-id="element-6"></div>

              <div className={`w-14 h-14 rounded-2xl bg-bg-main border ${benefit.borderColor} flex items-center justify-center text-3xl mb-2 relative z-10`} data-id="element-7">
                {benefit.icon}
              </div>
              <h3 className="text-xl font-bold text-text-main relative z-10" data-id="element-8">
                {benefit.title}
              </h3>
              <p className="text-text-sec leading-relaxed text-base relative z-10" data-id="element-9">
                {benefit.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}